import React from "react";

function ContactPage() {
  const isBusinessHours = () => {
    const now = new Date();
    const cstOffset = -6;
    const utcHours = now.getUTCHours();
    const cstHours = (utcHours + cstOffset + 24) % 24;
    const day = now.getUTCDay();
    const adjustedDay = cstHours < utcHours ? (day - 1 + 7) % 7 : day;

    const isWeekday = adjustedDay >= 1 && adjustedDay <= 5;
    const isWorkingHours = cstHours >= 9 && cstHours < 17;

    return isWeekday && isWorkingHours;
  };

  const googleMapsUrl =
    "https://www.google.com/maps/search/?api=1&query=17608+Woolworth+Ave+Omaha+NE+68130";

  return (
    <div className="contact-container">
      <div className="contact-header">
        <h1>Get In Touch</h1>
        <p>
          We're here to help bring your ideas to life. Reach out to us through
          any of the channels below.
        </p>
      </div>
      <div className="contact-grid">
        <a
          href="mailto:support@woolworthsoftware.com"
          className="contact-card contact-card-link"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <div className="contact-icon">✉️</div>
          <h3>Email</h3>
          <a href="mailto:support@woolworthsoftware.com">
            support@woolworthsoftware.com
          </a>
          <p>For general inquiries and support</p>
        </a>
        <a
          href={googleMapsUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="contact-card contact-card-link"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <div className="contact-icon">📍</div>
          <h3>Address</h3>
          <p>
            17608 Woolworth Ave
            <br />
            Omaha, NE 68130
          </p>
        </a>
        <a
          href="tel:402-960-4959"
          className="contact-card contact-card-link"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <div className="contact-icon">📞</div>
          <h3>Phone</h3>
          <p>
            {isBusinessHours() ? (
              <a href="tel:402-960-4959">402-960-4959</a>
            ) : (
              <span style={{ color: "#999" }}>402-960-4959</span>
            )}
          </p>
          <p>Mon-Fri, 9AM-5PM CST</p>
        </a>
      </div>
    </div>
  );
}

export default ContactPage;
